import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class ContactForm extends Component {

	setContact = (event) => {
		this.props.setContact(event.target.name, event.target.value);
	};

	sendContact = (event) => {
		event.preventDefault();
		this.props.setContactButtonState(true);
		this.props.sendContact();
	};

	renderButton = () => {
		const { contactButtonDisabled } = this.props;

		if(contactButtonDisabled){
			return (
				<button className="btn btn-amiko" type="submit" tabIndex="5" disabled>
					<i className="fa fa-spinner fa-pulse"></i>
				</button>
			);
		}

		return (
			<button className="btn btn-amiko" type="submit" tabIndex="5"
			        onClick={this.sendContact}>
				<FormattedMessage id="contact.submit" />
			</button>
		);
	};

	render() {
		const { name, email, phone, message} = this.props;

		return (
			<form className="contact-form" method="POST" action="#">
				<div className="form-group">
					<label>
						<FormattedMessage id="contact.label.name" />
					</label>
					<FormattedMessage id="contact.label.name">
						{
							(msg) => (
								<input className="form-control"
								       type="text" name="name" placeholder={msg} tabIndex="1"
								       value={name} onChange={this.setContact}/>
							)
						}
					</FormattedMessage>
				</div>
				<div className="form-group">
					<label>
						<FormattedMessage id="contact.label.email" />
					</label>
					<FormattedMessage id="contact.label.email">
						{
							(msg) => (
								<input className="form-control" type="email" name="email"
							       placeholder={msg} tabIndex="2"
							       value={email} onChange={this.setContact}/>
							)
						}
					</FormattedMessage>
				</div>
				<div className="form-group">
					<label>
						<FormattedMessage id="contact.label.phone" />
					</label>
					<FormattedMessage id="contact.label.phone">
						{
							(msg) => (
								<input className="form-control" type="phone" name="phone"
								       placeholder={msg} tabIndex="3"
								       value={phone} onChange={this.setContact} />
							)
						}
					</FormattedMessage>
				</div>
				<div className="form-group">
					<label>
						<FormattedMessage id="contact.label.message" />
					</label>
					<FormattedMessage id="contact.label.message">
						{
							(msg) => (
								<textarea className="form-control" name="message"
								          placeholder={msg} tabIndex="4"
								          value={message} onChange={this.setContact}/>
							)
						}
					</FormattedMessage>
				</div>
				{this.renderButton()}
			</form>
		);
	}
}

export default ContactForm;


// WEBPACK FOOTER //
// ./src/components/form/ContactForm.js